import { DsLanguageMap, DsDropshippingGuideI18nTemplate } from './dsTypes';

export const dsShippingTemplate: DsLanguageMap<DsDropshippingGuideI18nTemplate['shipping']> = {
  zh: {
    lockedTitle: '发货至海外仓',
    lockedDescription: '获得4个国内集货仓地址和完整发货指引。提供海运、空运双清包税服务，价格含报关费用和进出口税费。商品到达后5天内上架，快速启动销售。',
    lockedFeature1: '深圳、金华、东莞4个集货仓',
    lockedFeature2: '双清包税，无需担心报关',
    lockedFeature3: '透明的物流费用和扣费规则',
    lockedFeature4: '5天内完成海外仓上架',
    actionOpenAccount: '立即开户',
    actionContact: '联系客服',
    cardPrecheckTitle: '发货前检查',
    cardPrecheckDescription: '发货前请对照清单检查，确保各项准备已完成。',
    precheckOmsProductTitle: 'OMS中的商品信息',
    precheckOmsProductItem1: '尺寸、重量、申报价格准确',
    precheckOmsProductItem2: 'SKU与电商平台中的商品SKU一致（推荐）',
    precheckOmsInboundTitle: 'OMS中的入库单信息',
    precheckOmsInboundItem1: '美国海外仓、到仓方式、入库类型正确',
    precheckOmsInboundItem2: '箱子和产品的数量、尺寸、重量准确',
    precheckOmsInboundItem3: '入库单已提交审核',
    precheckProductTitle: '商品',
    precheckProductItem1: '已使用不透明材料独立包装',
    precheckProductItem2: '包装有一个面大于10×15cm',
    precheckProductItem3: '每个包装上都有商品条码',
    precheckProductItem4: '每个商品条码上都有 Made in China',
    precheckProductItem5: '每个商品条码可被扫描且结果与OMS中的SKU完全一致',
    precheckCartonTitle: '纸箱',
    precheckCartonItem1: '每个纸箱上都有6张箱唛',
    precheckCartonItem2: '每个纸箱上至少有一处 Made in China',
    precheckCartonItem3: '每个纸箱混装不超过4种商品并已做好分隔',
    cardShipmentTitle: '发货',
    cardShipmentDescription: '请将商品自行送往任意集货仓，随后支付国际物流费。',
    sectionCollectionWarehouseTitle: '集货仓地址',
    warehouseLabelReceiver: '收件人',
    warehouseLabelPhone: '电话',
    warehouseLabelAddress: '地址',
    noCollectionWarehouse: '暂无集货仓信息，请联系客服',
    sectionFreightDeductionTitle: '扣除国际物流费',
    freightRuleTitle: '扣费规则',
    freightRuleDescription: '收货时，集货仓会复核商品的类型、尺寸和重量，并出具国际物流最终报价。你确认报价后，费用将从OMS中扣除。',
    actionTopup: '充值',
    cardShelvingTitle: '上架',
    cardShelvingDescription: '美国海外仓会在收货后5天内上架商品，并从OMS中扣除入库费。',
    noteShelving: '上架时，美国海外仓会复核商品的尺寸和重量，并在OMS中予以修正。',
    sectionViewWarehouseProductsTitle: '查看美国海外仓中的商品',
    checkProductInfoTitle: '确认商品信息',
    checkProductInfoDescription: '确认商品尺寸、重量是否正确。',
    actionViewProducts: '查看商品',
    checkInventoryTitle: '确认商品库存',
    checkInventoryDescription: '确认美国海外仓库存是否正确。',
    actionViewInventory: '查看库存',
    sectionInboundFeeTitle: '扣除美国海外仓入库费',
    extraFeeConditionsTitle: '额外扣费的情形',
    extraFeeConditionsDescription: '当出现以下情况时，我们会按照美国海外仓其他服务的收费标准，额外收取包装、贴标、清点费。',
    actionPricing: '收费标准',
    extraFeeConditionItem1: '商品未按要求包装',
    extraFeeConditionItem2: '商品未按要求装箱',
    extraFeeConditionItem3: '商品未按要求粘贴条码',
    extraFeeConditionItem4: '你要求美国海外仓在上架前清点商品',
  },
  en: {
    lockedTitle: 'Ship to overseas warehouse',
    lockedDescription: 'Get full shipment guidance and domestic consolidation warehouse addresses. Sea/air duty-paid services include customs and import/export taxes. Products are shelved within 5 days after arrival.',
    lockedFeature1: '4 consolidation warehouses in China',
    lockedFeature2: 'Duty-paid clearance included',
    lockedFeature3: 'Transparent logistics charging rules',
    lockedFeature4: 'Shelving completed within 5 days',
    actionOpenAccount: 'Open account',
    actionContact: 'Contact support',
    cardPrecheckTitle: 'Pre-shipment checklist',
    cardPrecheckDescription: 'Review the checklist before shipping to ensure all preparation is completed.',
    precheckOmsProductTitle: 'Product info in OMS',
    precheckOmsProductItem1: 'Accurate dimensions, weight, and declared value',
    precheckOmsProductItem2: 'SKU matches platform SKU (recommended)',
    precheckOmsInboundTitle: 'Inbound order info in OMS',
    precheckOmsInboundItem1: 'Correct US warehouse, arrival method, and inbound type',
    precheckOmsInboundItem2: 'Accurate carton/product quantity, dimensions, and weight',
    precheckOmsInboundItem3: 'Inbound order submitted for review',
    precheckProductTitle: 'Products',
    precheckProductItem1: 'Individually packed with opaque materials',
    precheckProductItem2: 'At least one package side is larger than 10×15cm',
    precheckProductItem3: 'Each package has product barcode',
    precheckProductItem4: 'Each product barcode includes Made in China',
    precheckProductItem5: 'Each barcode is scannable and matches OMS SKU exactly',
    precheckCartonTitle: 'Cartons',
    precheckCartonItem1: 'Each carton has 6 labels',
    precheckCartonItem2: 'Each carton has at least one Made in China mark',
    precheckCartonItem3: 'No more than 4 product types per carton and properly separated',
    cardShipmentTitle: 'Shipment',
    cardShipmentDescription: 'Deliver products to any consolidation warehouse, then pay international freight.',
    sectionCollectionWarehouseTitle: 'Consolidation warehouse addresses',
    warehouseLabelReceiver: 'Receiver',
    warehouseLabelPhone: 'Phone',
    warehouseLabelAddress: 'Address',
    noCollectionWarehouse: 'No consolidation warehouse available. Please contact support.',
    sectionFreightDeductionTitle: 'International freight deduction',
    freightRuleTitle: 'Charging rule',
    freightRuleDescription: 'At receiving time, consolidation warehouse re-checks product type, dimensions, and weight, then issues final international quote. After confirmation, fees are deducted from OMS.',
    actionTopup: 'Top up',
    cardShelvingTitle: 'Shelving',
    cardShelvingDescription: 'US warehouses shelf products within 5 days after receipt and deduct inbound fees from OMS.',
    noteShelving: 'During shelving, US warehouse will re-check dimensions and weight and update OMS if needed.',
    sectionViewWarehouseProductsTitle: 'View products in US warehouse',
    checkProductInfoTitle: 'Verify product info',
    checkProductInfoDescription: 'Verify product dimensions and weight.',
    actionViewProducts: 'View products',
    checkInventoryTitle: 'Verify inventory',
    checkInventoryDescription: 'Verify US warehouse inventory accuracy.',
    actionViewInventory: 'View inventory',
    sectionInboundFeeTitle: 'US warehouse inbound fee deduction',
    extraFeeConditionsTitle: 'Scenarios with extra charges',
    extraFeeConditionsDescription: 'In the following scenarios, extra packaging, relabeling, and counting fees will be charged based on US warehouse service pricing.',
    actionPricing: 'Pricing',
    extraFeeConditionItem1: 'Products are not packaged per requirement',
    extraFeeConditionItem2: 'Products are not boxed per requirement',
    extraFeeConditionItem3: 'Products are not labeled per requirement',
    extraFeeConditionItem4: 'You request pre-shelving product counting in US warehouse',
  },
};
